

import { FC, PropsWithChildren, SyntheticEvent, useCallback } from 'react';

import { Dialog } from '@eneco/sparky';
import { DialogProps } from '@eneco/sparky/types';
import { keepFromTracking, useTracking, useGTM } from '@eneco/tracking';

interface CompoundProps {
  Close: typeof Dialog.Close;
}

export const TrackedDialog: FC<PropsWithChildren<DialogProps>> & CompoundProps = ({ children, ...props }) => {
  const { scope } = useTracking();
  const { pushToDataLayer } = useGTM();

  const onCloseHandler = useCallback(
    (event?: SyntheticEvent<HTMLButtonElement, Event>) => {
      // make sure the automatic event tracking of the close button is cancelled
      keepFromTracking(event);

      // fire a custom select_button event instead
      pushToDataLayer({
        event: 'select_button',
        component_name: scope,
        component_type: 'dialog',
        selected_content: 'close',
        selected_action: 'close',
      });
    },
    [scope],
  );

  return (
    <Dialog onClose={onCloseHandler} {...props}>
      {children}
    </Dialog>
  );
};

TrackedDialog.Close = Dialog.Close;
